export const subscriptionType = (isTrial) => (isTrial ? 'trial' : 'organic');

export default {
  subscriptionType
};
